<template>
	<div class="xs p4 bg5">
		<div class="flex pb4">
			<div class="xs-6 pr2">
				<span class="fs3">{{ $t("font_family") }}</span>
				<j-base-select
					size="small"
					:value="getFontFamily"
					@input="setFontFamily($event)"
					:options="fontList"
				/>
			</div>

			<div class="xs-6 pl2">
				<span class="fs3">{{ $t("font_size") }}</span>
				<j-base-select
					size="small"
					:value="getFontSize"
					@input="setFontSize($event)"
					:options="fontSizes"
				/>
			</div>
		</div>

		<div class="flex pb4">
			<div class="xs-6">
				<div class="fs3 pb1">
					<span>{{ $t("text_align") }}</span>
				</div>

				<div class="flex pb2">
					<div
						v-for="(icon, i) in horizontalAlignmentIcons"
						:key="`h${i}`"
						@click="setTextAlignment(icon)"
					>
						<crm-icon
							class="p2"
							:class="{ 'r1 bg2': form.textAlignment === icon.toUpperCase() }"
							:name="`align-${icon}`"
							:color="form.textAlignment === icon.toUpperCase() ? 'c5' : 'c1'"
						/>
					</div>
				</div>
			</div>

			<!-- <div class="xs-6">
				<div class="fs3 pb1">
					<span>{{ $t("vertical_align") }}</span>
				</div>
				<div class="flex pb2">
					<div
						v-for="(icon, i) in verticalAlignmentIcons"
						:key="`v${i}`"
						@click="setVerticalAlignment(icon)"
					>
						<crm-icon
							class="p2"
							:name="`vertical-align-${icon}`"
							:class="{ 'r1 bg2': verticalAlignment === icon }"
							:color="verticalAlignment === icon ? 'c5' : 'c1'"
						/>
					</div>
				</div>
			</div>-->
		</div>

		<div class="pb2">
			<div class="fs3 pb1">
				<span>{{ $t("text_or_liquid") }}</span>
			</div>
			<div>
				<j-base-input-long-text
					v-model="form.liquidSource"
					:rows="10"
					resize="none"
				/>
			</div>
		</div>

		<div class="pb2 flex mb2">
			<div class="xs-3 pr2">
				<p class="fs3 pb1">x</p>
				<j-base-input-number size="xsmall" :value="getX" @input="setX($event)" />
			</div>
			<div class="xs-3 pr2">
				<p class="fs3 pb1">y</p>
				<j-base-input-number size="xsmall" :value="getY" @input="setY($event)" />
			</div>
			<div class="xs-3 pr2">
				<p class="fs3 pb1">{{ $t("width") }}</p>
				<j-base-input-number :value="getWidth" size="xsmall" @input="setWidth" />
			</div>
			<div class="xs-3 pr2">
				<p class="fs3 pb1">{{ $t("height") }}</p>
				<j-base-input-number :value="getHeight" size="xsmall" @input="setHeight" />
			</div>
		</div>

		<div class="pb2 flex">
			<div class="xs-3 pr2">
				<p class="fs3 pb1">Page</p>
				<j-base-input-number size="xsmall" v-model="form.page" />
			</div>
		</div>

		<div class="flex xs-between mt4 bc7 bt1 pt4">
			<div>
				<j-button
					class="mr2"
					type="primary"
					size="small"
					@click="savePdfDrawing"
				>{{ $t("save") }}</j-button>
				<j-button
					type="secondary"
					size="small"
					@click="duplicatePdfDrawing"
				>{{ $t("duplicate") }}</j-button>
			</div>

			<j-button
				type="error"
				size="small"
				@click="removePdfDrawing"
			>{{ $t("delete") }}</j-button>
		</div>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon"
import JBaseInputSearch from "@/components/JBaseInputSearch"
import JBaseInputNumber from "@/components/JBaseInputNumber"
import JBaseInputText from "@/components/JBaseInputText"
import JBaseInputLongText from "@/components/JBaseInputLongText"
import JButton from "@/components/JButton"
import JBaseSelect from "@/components/JBaseSelect"

import api from "../../api"

import fontList from "./fontList"

export default {
	components: {
		CrmIcon,
		JBaseInputSearch,
		JBaseInputText,
		JBaseInputNumber,
		JBaseInputLongText,
		JButton,
		JBaseSelect
	},

	props: {
		drawings: {
			type: Array,
			default: () => []
		},
		activeObject: {
			type: Object
		}
	},

	data() {
		return {
			form: {
				point1: {
					x: null,
					y: null
				},
				point2: {
					x: null,
					y: null
				},
				liquidSource: null,
				page: null,
				font: {
					familyName: null,
					emSize: null,
					fontStyle: "REGULAR"
				},
				verticalAlignment: null,
				textAlignment: null
			},

			editingWidth: null,

			isLoading: false
		}
	},

	methods: {
		setX(value) {
			const diff = this.form?.point1?.x - value
			this.form.point1.x = value
			this.form.point2.x -= diff
		},
		setY(value) {
			const diff = this.form?.point1?.y - value
			this.form.point1.y = value
			this.form.point2.y -= diff
		},
		setWidth(value) {
			this.form.point2.x = parseInt(this.form?.point1?.x) + parseInt(value)
		},
		setHeight(value) {
			this.form.point2.y = parseInt(this.form?.point1?.y) + parseInt(value)
		},
		setTextAlignment(value) {
			this.form.textAlignment = value?.toUpperCase()
		},
		setFontFamily(value) {
			this.form = {
				...this.form,
				font: {
					...this?.form?.font,
					familyName: value,
					fontStyle: "REGULAR"
				}
			}
		},
		setFontSize(value) {
			this.form = {
				...this.form,
				font: { ...this?.form?.font, emSize: parseInt(value) }
			}
		},
		async savePdfDrawing() {
			this.isLoading = true

			// set default font if none selected on save
			if (!this.form?.font) {
				this.form.font = {
					familyName: "Arial",
					fontStyle: "REGULAR",
					emSize: 8
				}
			}

			const res = await api.updatePdfDrawing({
				templateId: this.$route.params.id,
				drawingId: this.computedActiveObject?.id,
				input: this.form
			})
			this.isLoading = false

			this.$emit("updated:pdfDrawing")
		},

		removePdfDrawing() {
			this.$emit("removed:pdfDrawing", this.computedActiveObject?.id)
		},
		duplicatePdfDrawing() {
			this.$emit("duplicated:pdfDrawing", this.computedActiveObject)
		}
	},

	computed: {
		getFontFamily() {
			return this.form?.font?.familyName
		},
		getFontSize() {
			return this.form?.font?.emSize
		},
		getX() {
			return parseInt(this.form.point1.x)
		},
		getY() {
			return parseInt(this.form.point1.y)
		},
		getWidth() {
			const point1 = this?.form?.point1?.x || 0
			const point2 = this?.form?.point2.x || 0
			return parseInt(point2 - point1)
		},
		getHeight() {
			const point1 = this?.form?.point1?.y || 0
			const point2 = this?.form?.point2.y || 0
			return parseInt(point2 - point1)
		},

		computedActiveObject() {
			return this.drawings?.find(item => item.id === this.activeObject.id)
		},

		horizontalAlignmentIcons() {
			return ["left", "center", "right"]
		},
		verticalAlignmentIcons() {
			return ["top", "center", "bottom"]
		},
		fontList() {
			return fontList.fonts.map(font => {
				return {
					value: font,
					name: font
				}
			})
		},
		defaultFontFamily() {
			return this.activeObject
				? this.activeObject?.font?.familyName
				: this.fontFamily
		},
		fontSizes() {
			let output = []
			for (let i = 1; i < 64; i++) {
				output.push({
					value: i,
					name: i.toString()
				})
			}
			return output
		},
		defaultFontSize() {
			return this.activeObject
				? this.activeObject?.font?.emSize?.toString()
				: this.fontSize
		}
	},

	watch: {
		activeObject: {
			handler() {
				this.form = { ...this.computedActiveObject }
				delete this.form.id
			}
		},
		drawings: {
			handler() {
				this.form = { ...this.computedActiveObject }
				delete this.form.id
			}
		}
	}
}
</script>